import {
  Bar,
  CartesianGrid,
  LabelList,
  BarChart as RechartsBarChart,
  ResponsiveContainer,
  Text,
  XAxis,
  YAxis,
} from 'recharts';
import { Orientation } from '../../../types';
import { truncateText } from '../../../utils';
import { Typography, TypographyType } from '../Typography';
import { AxisType, BarChartKeys, BarChartProps } from './Barchart.types';

// Bar chart constants
// Bar size is the height of the bar
const BAR_SIZE = 16;
// Padding between the bars
const BAR_PADDING = 12;
// Border radius of the bars
const BAR_BORDER_RADUIS = 4;
// Height of the x axis labels
const X_AXIS_LABEL_HEIGHT = 32;
// Width of the y axis labels
const Y_AXIS_LABEL_WIDTH = 100;
// Vertical offset for Y-axis labels
const Y_AXIS_LABEL_OFFSET = 4;

const BarChart = ({ data, title, valueFormatter }: BarChartProps) => {
  // Calculate the height of the chart based on the number of bars and the height of each bar
  const chartHeight = data.length * (BAR_SIZE + 2 * BAR_PADDING) + X_AXIS_LABEL_HEIGHT;

  return (
    <div className="flex w-full flex-col gap-4">
      <Typography type={TypographyType.H4}>{title}</Typography>
      <ResponsiveContainer height={chartHeight}>
        <RechartsBarChart layout={Orientation.VERTICAL} data={data} margin={{ right: 30, left: Y_AXIS_LABEL_WIDTH }}>
          <CartesianGrid horizontal={false} className="stroke-base-200" />
          <XAxis type={AxisType.NUMBER} axisLine={false} tickLine={false} tickFormatter={valueFormatter} />
          <YAxis
            type={AxisType.CATEGORY}
            dataKey={BarChartKeys.LABEL}
            axisLine={{ className: 'stroke-base-200' }}
            tickLine={false}
            tick={(props) => {
              const { x, y, payload } = props;
              return (
                <Text x={x} y={y} dy={Y_AXIS_LABEL_OFFSET} textAnchor="end">
                  {truncateText(payload.value, Y_AXIS_LABEL_WIDTH)}
                </Text>
              );
            }}
          />
          <Bar dataKey={BarChartKeys.VALUE} className="fill-primary" radius={BAR_BORDER_RADUIS} barSize={BAR_SIZE}>
            <LabelList position="right" className={TypographyType.X_SMALL} formatter={valueFormatter} />
          </Bar>
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChart;
